// @ts-expect-error we are importing a JS file
import { enableGetResponse } from "@/lib/consent/getResponseLoader.js";
import { CAT_MARKETING } from "@/lib/consent/googleConsent";

export const SERVICE_GET_RESPONSE = "get_response";

declare global {
  interface Window {
    __GR_ID__?: string;
  }
}

export function updateGetResponseConsent(CookieConsent: {
  acceptedService: (service: string, category: string) => boolean;
  acceptedCategory: (category: string) => boolean;
}) {
  if (!CookieConsent.acceptedService(SERVICE_GET_RESPONSE, CAT_MARKETING)) {
    return;
  }

  window.__GR_ID__ = import.meta.env.VITE_GR_ID;

  enableGetResponse();
}
